import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';
import CheckIcon from 'images/icons/check.svg';
import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';
import Image from 'components/Image';

const SolutionRPAPage = ({ path }) => (
  <>
    <Meta
      title="Robotic Process Automation (RPA) | ATC Digital Business Solutions"
      description="With Robotic Process Automation (RPA) tools, ATC will make your company's idea come true by developing and deploying high-value technological solutions."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/RPA-bg_1.png"
          title="Robotic Process Automation RPA - Work Reimagined."
          style={{ paddingBottom: 140 }}
          altTitle={
            <div className="col-md-6">
              <div className="rpa-img">
                <Image
                  src="solutions/ATCX.png"
                  alt="atcximage"
                  style={{ width: 220, marginTop: '12px' }}
                />
              </div>
              <div className="rpa-text">
                We partner with AutomationEdge to offer a comprehensive suite of
                RPA services tailored specifically towards meeting your needs.
              </div>
            </div>
          }
        >
          <div>
            <p
              className="white-txt"
              style={{
                fontSize: 18,
                letterSpacing: 0.2,
                lineHeight: '28px',
              }}
            >
              With the automation of menial or redundant tasks, your employees
              can get back to work on the stuff that matters to the success of
              your business.
            </p>
          </div>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>
       <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Unlock Your Company’s True Potential
                </h2>
                <p className="white-txt">
                  Robotic Process Automation (RPA) shifts focus from constraints
                  to upskilling resources that can contribute to strategic
                  objectives. From screen scraping, verifying data, to
                  generating intuitive business intelligence dashboards, RPA can
                  perform complex and sequenced actions that mimic human
                  intelligence. And here is the clincher: RPAs work 24x7.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="roboticProcessAutomation"
          flyText="Robotic Process Automation"
          flyBoxImage="solutions/rpa-box.jpg"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Disrupt your tech, not your workplace
                </h2>
                <p>
                  Forget about system integration. RPA is readily implementable,
                  works with any system, and connects disparate systems to
                  perform tasks. Automation does not disturb underlying business
                  systems and processes. Data extraction and processing,
                  document and signature verification, and approvals based on
                  standard checklists are a few examples of tasks that can be
                  automated to eliminate human error, improve reliability, and
                  increase operational efficiency. Also, you can rapidly create
                  multiple RPA instances to scale on demand.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    How does it
                    <br />
                    work?
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Automation</h3>
                        <p>Automate redundant tasks.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Reliability</h3>
                        <p>Improve reliability by reducing human error.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Efficiency</h3>
                        <p>Increase efficiency by extracting exact data.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>24/7</h3>
                        <p>
                          Have piece of mind knowing the job is getting done
                          24/7.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionRPAPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionRPAPage;
